import React, { useMemo } from "react";
import { Field } from "react-final-form";
import { getData } from "country-list";
import Autocomplete from "../../../../../../../components/Autocomplete";
import BootstrapInput from "../../../../../../../components/BootstrapInput";

export default function Agent() {
  const countries = useMemo(
    () =>
      getData().sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
      ),
    [],
  );

  return (
    <>
      <Field
        required
        fullWidth
        type="text"
        name="agentProfile.name"
        label="Company Name"
        placeholder="Company Name"
        component={BootstrapInput}
      />
      <Field
        required
        fullWidth
        name="agentProfile.country"
        label="Country"
        placeholder="Please Select"
        options={countries}
        component={Autocomplete}
      />
      <Field
        fullWidth
        type="text"
        name="agentProfile.website"
        label="Website"
        placeholder="Website"
        component={BootstrapInput}
      />
      <Field
        required
        fullWidth
        type="text"
        name="name"
        label="Full Name"
        placeholder="Full Name"
        component={BootstrapInput}
      />
      <Field
        required
        fullWidth
        type="text"
        name="agentProfile.title"
        label="Position"
        placeholder="Position"
        component={BootstrapInput}
      />
    </>
  );
}
